import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=c61dbc52"
import script from "./RichTextEditor.vue?vue&type=script&lang=ts"
export * from "./RichTextEditor.vue?vue&type=script&lang=ts"
import style0 from "./RichTextEditor.vue?vue&type=style&index=0&id=c61dbc52&prod&%3Ascoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports